import type { ReactNode } from 'react';

import { useIslandSection } from './magic-island';
import type { IslandMode } from './magic-island';

const SUPPRESS_ISLAND: IslandMode = { kind: 'hidden' };

/**
 * Blanks the Magic Island across a page's whole closing run.
 *
 * Past the last item-related section the page has stopped talking about the
 * item, so the enquiry pill has nothing left to act on — it would float the
 * page's previous ask over the ones that replaced it, Get Matched and the
 * account band.
 *
 * The claim covers the run rather than each block inside it. The island falls
 * back to the enquiry pill whenever no section holds the reading line, and the
 * spacers between the closing's blocks hold nothing — so suppressing block by
 * block flashes the pill back on in each gap. One claim over the whole region
 * keeps it down until the site footer, which the island already binds against.
 */
export const IslandFreeClosing = ({
    children,
    className,
}: {
    children: ReactNode;
    className?: string;
}) => {
    const suppressRef = useIslandSection<HTMLDivElement>(SUPPRESS_ISLAND);
    return (
        <div ref={suppressRef} className={className}>
            {children}
        </div>
    );
};
